import { render, staticRenderFns } from "./studentDialogueDataDialog.vue?vue&type=template&id=e045cb8e&scoped=true"
import script from "./studentDialogueDataDialog.vue?vue&type=script&lang=js"
export * from "./studentDialogueDataDialog.vue?vue&type=script&lang=js"
import style0 from "./studentDialogueDataDialog.vue?vue&type=style&index=0&id=e045cb8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e045cb8e",
  null
  
)

export default component.exports